<template>
    <el-container class="c-main-layuout">
        <el-aside :style="leftStyle" v-if="showLeft">
            <slot name="left"></slot>
        </el-aside>
        <el-main style="padding: 0px">
            <slot name="main"></slot>
        </el-main>
        <el-aside :style="rightStyle" v-if="showRight">
            <slot name="right"></slot>
        </el-aside>
    </el-container>
</template>

<script>
export default {
    props: {
        leftAsideWidth: {
            // 左侧宽度
            type: String,
            default() {
                return '320px';
            },
        },
        rightAsideWidth: {
            // 右侧宽度
            type: String,
            default() {
                return '320px';
            },
        },
        showLeft: {
            // 是否有左侧栏
            type: Boolean,
            default: true,
        },
        showRight: {
            // 是否有右侧栏
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        leftStyle() {
            let leftAsideWidth = this.leftAsideWidth;
            let sty = {
                width: leftAsideWidth,
            };
            return sty;
        },
        rightStyle() {
            let rightAsideWidth = this.rightAsideWidth;
            let sty = {
                width: rightAsideWidth,
            };
            return sty;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-main-layuout {
    height: 100%;
}
</style>
